module.exports = __webpack_public_path__ + "static/media/Mike Turpin.9a94e2a0.jpg";